import { mergeStyleSets, getTheme } from '@fluentui/react';
import type { ITheme } from '@fluentui/react';

const theme: ITheme = getTheme();

export const getHeroBannerStyles = (gradient: string) =>
  mergeStyleSets({
    root: {
      background: gradient,
      borderRadius: 16,
      marginBottom: 28,
      color: theme.palette.white,
      boxShadow: theme.effects.elevation16,
      selectors: {
        '@media (max-width: 768px)': {
          borderRadius: 10,
          marginBottom: 20,
        },
      },
    },
    title: {
      fontSize: 26,
      fontWeight: 700,
      color: theme.palette.white,
      margin: '0 0 6px 0',
      letterSpacing: '-0.3px',
      selectors: {
        '@media (max-width: 1025px)': {
          fontSize: 22,
        },
        '@media (max-width: 768px)': {
          fontSize: 20,
        },
      },
    },
    subtitle: {
      fontSize: theme.fonts.medium.fontSize,
      color: theme.palette.white,
      opacity: 1,
      margin: 0,
    },
    actionButton: {
      background: 'rgba(255,255,255,0.15)',
      color: '#ffffff',
      borderColor: 'rgba(255,255,255,0.4)',
      borderRadius: 8,
      fontWeight: 700,
      fontSize: 15,
      minWidth: 'auto',
      padding: '0 14px',
    },
    actionButtonHovered: {
      background: 'rgba(255,255,255,0.25)',
      color: '#ffffff',
      borderColor: 'rgba(255,255,255,0.6)',
    },
    badge: {
      background: 'rgba(255,255,255,0.25)',
      padding: '2px 8px',
      borderRadius: 10,
      fontSize: theme.fonts.xSmall.fontSize,
      marginLeft: 4,
    },
  });

export const heroBannerGradients = {
  teal: `linear-gradient(135deg, ${theme.palette.tealDark} 0%, ${theme.palette.teal} 100%)`,
  blue: `linear-gradient(135deg, ${theme.palette.blueDark} 0%, ${theme.palette.blue} 100%)`,
  dark: `linear-gradient(135deg, ${theme.palette.neutralDark} 0%, ${theme.palette.tealDark} 50%, ${theme.palette.teal} 100%)`,
};
